import { ReactNode } from "react";
import { cn } from "@boostdev/design-system-components/utils";
import css from "./MainContainer.module.css";

interface MainContainerProps {
  children: ReactNode;
  className?: string;
}

export function MainContainer({ children, className }: MainContainerProps) {
  return (
    <div className={cn(["utl-main-grid", css.main, className])}>{children}</div>
  );
}
